import getConfig from "next/config";

const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();

const isServer = typeof window === "undefined";

export default {
  ...(isServer ? serverRuntimeConfig : publicRuntimeConfig),
};
